
export default function Contact() {
  const contactInfo = [
    { label: 'Address', value: 'Latinski trg 6', icon: 'ri-map-pin-line' },
    { label: 'City', value: 'Ljubljana', icon: 'ri-building-line' },
    { label: 'Zip', value: '1000', icon: 'ri-mail-line' },
    { label: 'Country', value: 'Slovenia', icon: 'ri-global-line' },
    { label: 'Email', value: 'help@delkodoo.com', icon: 'ri-mail-send-line', isLink: true },
    { label: 'Number', value: '+1 4342787185', icon: 'ri-phone-line', isLink: true }
  ];

  return (
    <section id="contact" className="py-32 bg-gradient-to-br from-teal-50 via-white to-cyan-50">
      <div className="max-w-7xl mx-auto px-6">
        <div className="text-center mb-16">
          <h2 className="text-6xl font-bold text-gray-900 mb-4">Get In Touch</h2>
          <p className="text-xl text-gray-600 max-w-2xl mx-auto">
            Have questions about our applications? We're here to help
          </p>
        </div>

        <div className="bg-white rounded-3xl shadow-2xl p-12 max-w-4xl mx-auto">
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {contactInfo.map((info, index) => (
              <div key={index} className="flex items-start gap-4">
                <div className="w-12 h-12 flex items-center justify-center bg-teal-100 rounded-lg flex-shrink-0">
                  <i className={`${info.icon} text-2xl text-teal-600`}></i>
                </div>
                <div>
                  <p className="text-sm font-semibold text-gray-500 uppercase tracking-wide mb-1">
                    {info.label}
                  </p>
                  {info.isLink && info.label === 'Email' ? (
                    <a 
                      href={`mailto:${info.value}`}
                      className="text-lg font-medium text-gray-900 hover:text-teal-600 transition-colors cursor-pointer"
                    >
                      {info.value}
                    </a>
                  ) : info.isLink && info.label === 'Number' ? (
                    <a 
                      href={`tel:${info.value}`}
                      className="text-lg font-medium text-gray-900 hover:text-teal-600 transition-colors cursor-pointer"
                    >
                      {info.value}
                    </a>
                  ) : (
                    <p className="text-lg font-medium text-gray-900">{info.value}</p>
                  )}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>

      {/* Footer */}
      <footer className="mt-24 pt-12 border-t border-gray-200">
        <div className="max-w-7xl mx-auto px-6">
          <div className="flex flex-col md:flex-row justify-between items-center gap-6">
            <div className="flex items-center gap-3">
              <img 
                src="https://public.readdy.ai/ai/img_res/924ba4d8-6ba6-40d3-9855-21a22ec5b434.png" 
                alt="DELKO d.o.o. Logo" 
                className="h-8 w-8 object-contain"
              />
              <span className="text-lg font-semibold text-gray-900">DELKO d.o.o.</span>
            </div>
            <p className="text-sm text-gray-600">
              © 2025 DELKO d.o.o. All rights reserved.
            </p>
            <div className="flex items-center gap-4">
              <a href="#home" className="w-10 h-10 flex items-center justify-center bg-gray-900 rounded-full hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-linkedin-fill text-lg text-white"></i>
              </a>
              <a href="#home" className="w-10 h-10 flex items-center justify-center bg-gray-900 rounded-full hover:bg-teal-600 transition-colors cursor-pointer">
                <i className="ri-twitter-x-fill text-lg text-white"></i>
              </a>
            </div>
          </div>
        </div>
      </footer>
    </section>
  );
}
